import * as React from "react";
const SplashNotInternet: React.FC<any> = props => {
  return (
    <div className="splashFull">
      <a rel="dofollow" href="#home">
        <img
          src="/images/logo.svg"
          className="splashLogo"
          alt="Teatr Horzycy Logo"
        />
      </a>
      <p className="mt-5"> Sprzedaż biletów online została zakończona. </p>
      <p>Sprawdź dostępność w kasie tel.: 56 622 30 70.</p>
    </div>
  );
};

export default SplashNotInternet;
